import type { SSEvent } from './event-store';
import { summarize } from './event-coalesce';

const typeColors: Record<string, string> = {
  heartbeat: 'bg-chart-2',
  'tool-call': 'bg-success',
  'tool-start': 'bg-success',
  system: 'bg-muted-foreground',
  'cron-result': 'bg-chart-4',
  'approval-request': 'bg-destructive',
  'chat-response': 'bg-primary',
};

export function EventCard({ event, count = 1 }: { event: SSEvent; count?: number }) {
  const color = typeColors[event.type] ?? 'bg-muted-foreground';
  const time = new Date(event.timestamp).toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });

  return (
    <div className="px-3 py-2 bg-muted rounded-lg">
      <div className="flex items-center justify-between gap-2">
        <div className="flex items-center gap-1.5 min-w-0">
          <span className={`w-1.5 h-1.5 rounded-full shrink-0 ${color}`} />
          <span className="font-mono text-[length:var(--text-base)] text-foreground/80 truncate">{event.type}</span>
          {count > 1 && (
            <span className="font-mono text-[length:var(--text-sm)] text-muted-foreground tabular-nums shrink-0 px-1 rounded bg-foreground/5">×{count}</span>
          )}
        </div>
        <span className="font-mono text-[length:var(--text-sm)] text-muted-foreground tabular-nums shrink-0">{time}</span>
      </div>
      <div className="text-[length:var(--text-base)] text-muted-foreground mt-1 leading-snug">{summarize(event)}</div>
    </div>
  );
}
